import React from 'react';
import { BsInstagram, BsLinkedin, BsBehance} from 'react-icons/bs';
//import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
            <BsBehance />
        </div>
        <div>
            <BsLinkedin />
        </div>
        <div>
            <BsInstagram />
        </div>
    </div>
  )
}

export default SocialMedia